module.exports = __webpack_public_path__ + "img/plus-white.220a39f2.svg";